import CartHeaderContent from './CartHeaderContent';
import ViewOnScreen from '../../components/view-on-screen/ViewOnScreen';
import { BoxProps, useMediaQuery, useTheme } from '@mui/material';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { dispatchCloseMenuEvent, dispatchToggleMenuEvent } from '../../utils/menu';
import { getCartItemQuantityTotal } from '../../utils/cart';
import { Menu } from '../../types/menu';
import { RootState, useAppDispatch, useAppSelector } from '../../redux/store';
import { toggleCartHeaderDropdown } from '../../redux/slice/cartSlice';
import { useEffect, useRef, useState } from 'react';
import {
  CartButton,
  WrapperContainer,
  CartButtonWrapper,
  Count,
  Arrow,
  ArrowContainer,
  Header,
  PopoverWrapper,
  StyledPopover,
} from './CartHeaderStyle';

export interface CartHeaderProps extends BoxProps {}

export default function CartHeader({ ...rest }: CartHeaderProps) {
  const dispatch = useAppDispatch();
  const config = useAppSelector((state: RootState) => state.cart.cartHeaderConfig);

  const cart = useAppSelector((state: RootState) => state.cart);
  const cartIconRef = useRef<HTMLElement>(null);

  const [open, setOpen] = useState<boolean | undefined>(false);

  const theme = useTheme();
  const isSmallScreenBreakpoint = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.xs),
  );

  const handleClick = () => {
    dispatchToggleMenuEvent(Menu.CART_MENU);
  };

  const handleClickAway = () => {
    if (!isSmallScreenBreakpoint && open) {
      dispatchCloseMenuEvent(Menu.CART_MENU);
      dispatch(toggleCartHeaderDropdown({ open: false, index: -1 }));
    }
  };

  useEffect(() => {
    setTimeout(() => {
      cartIconRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 0);
  }, [open]);

  useEffect(() => {
    setOpen(config?.open);
  }, [config]);
  
  const totalQuantity = getCartItemQuantityTotal(cart.cartItems);

  return (
    <ClickAwayListener onClickAway={handleClickAway} {...rest}>
      <WrapperContainer ref={cartIconRef}>
        <CartButtonWrapper onClick={handleClick}>
          <CartButton></CartButton>
          {totalQuantity > 0 && <Count>{totalQuantity}</Count>}
        </CartButtonWrapper>

        {open ? (
          <ViewOnScreen screen={{ up: 'xs' }}>
            <StyledPopover>
              <ArrowContainer>
                <Arrow></Arrow>
              </ArrowContainer>
              <PopoverWrapper>
                <Header>
                  Cart ({totalQuantity} {totalQuantity === 1 ? 'item' : 'items'})
                </Header>
                <CartHeaderContent />
              </PopoverWrapper>
            </StyledPopover>
          </ViewOnScreen>
        ) : null}
      </WrapperContainer>
    </ClickAwayListener>
  );
}
